import React from 'react';
import {Route, Switch, useRouteMatch} from "react-router-dom";
import Lessons from "./Lessons";
import WatchLessons from "./WatchLessons";

function StudentLessons() {
  let {path} = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path} component={Lessons} />
      <Route path={`${path}/:lessons`} component={WatchLessons}/>
    </Switch>
  );
}

export default StudentLessons;